module.exports = __webpack_public_path__ + "static/media/hasura.5adeeee4.png";